export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/real_estate.4d66fed.svg";